<!--
 * @Author: 汪俊洪
 * @Date: 2021-10-08 19:14:52
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2024-02-27 15:59:04
 * @Description: 选择订单
-->
<template>
  <div class="wrap column">
    <Search :searchConfig="tableConfig" @doSearch="doSearch" />
    <Table
      :tableEvent="tableEvent"
      ref="table"
      class="table-wrap flex-1"
      :tableConfig="tableConfig"
    >
      <template :slot="'orderReturnProportion'" slot-scope="scope">
        {{ mul(scope.row.orderReturnProportion || 0, 100) }}
      </template>
    </Table>
    <div class="btns">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button
        class="mgl"
        size="small"
        :disabled="multipleSelection.length > 0 ? false : true"
        type="primary"
        @click="comfirm"
        >提交</el-button
      >
    </div>
  </div>
</template>

<script>
import Table from '@/components/table/index'
import Search from '@/components/search/index'
import { mul } from '@/utils/numberComputed'

export default {
  props: {
    companyId: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
    Table,
    Search
  },
  created () {
    this.tableData = [...this.list]
  },
  data () {
    return {
      tableData: [],
      multipleSelection: [], // 选中的值
      tableEvent: {
        'selection-change': v => {
          this.multipleSelection = v
        }
      },
      tableConfig: {
        searchType: 'totalPage',
        searchUrl: '/front/oms/shopping/invoiceApply/order/list', // 搜索接口
        searchMethod: 'POST', // 接口请求方式
        autoSearch: true, // 是否需要默认查询
        needPagination: true, // 是否需要分页
        fluidHeight: true, // 流体高度
        showOrdinal: true, // 是否显示序号,
        hideLabel: true, // 搜索隐藏label
        searchFlexStart: true, // 搜索按钮左对齐
        showCheckBox: true,
        checkBoxRowKey: 'orderCode',
        count: 'total',
        resultListName: 'records',
        checkSelectable: row => {
          const res = this.tableData.some(item => {
            if (item.orderCode === row.orderCode) {
              return true
            }
            return false
          })
          return !res
        },
        params: [
          {
            prop: 'orderCode',
            label: '订单编号',
            placeholder: '订单编号',
            width: '160px'
          },
          {
            prop: 'orderTotalAmount',
            label: '订单金额',
            valueType: 'money',
            hideInSearch: true
          },
          // {
          //   prop: 'orderReturnAmount',
          //   label: '已回款金额',
          //   valueType: 'money',
          //   hideInSearch: true
          // },
          // {
          //   prop: 'orderReturnProportion',
          //   label: '已回款比例(%)',
          //   hideInSearch: true,
          //   isSlot: true
          // },
          {
            prop: 'invoiceAmount',
            label: '已开票金额',
            valueType: 'money',
            hideInSearch: true
          },
          {
            prop: 'orderAuditSuccessTime',
            label: '订单确认时间',
            hideInSearch: true,
            columnsType: 'date'
          },
          {
            prop: 'sellerName',
            label: '主体',
            hideInSearch: true
          }
        ],
        extra: {
          companyId: this.companyId
        } // 额外的参数 搜索的条件
      }
    }
  },
  methods: {
    mul,
    doSearch (input) {
      this.tableConfig.extra = {
        // ...input,
        orderCodeList:
          input && input.orderCode ? input.orderCode.split(',') : [],
        companyId: this.companyId
      }
      this.$refs.table.getList()
    },
    // 关闭
    cancel () {
      this.$emit('cancel')
    },
    // 确认选择信息
    comfirm () {
      const ids = this.tableData.map(item => item.orderCode)
      const arr = JSON.parse(JSON.stringify(this.multipleSelection))
      this.tableData = [
        ...this.tableData,
        ...arr.filter(item => !ids.includes(item.orderCode))
      ]
      this.$emit('comfirm', [...this.tableData])
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  height: 500px;
}
.btns {
  padding: 30px 0 0;
  text-align: center;
  .mgl {
    margin-left: 32px;
  }
}
</style>
